module.exports = __webpack_public_path__ + "static/media/post-img3.4df74bf2.jpg";